import { render, staticRenderFns } from "./EligiblePhysicians.vue?vue&type=template&id=065b2586"
import script from "./EligiblePhysicians.vue?vue&type=script&lang=js"
export * from "./EligiblePhysicians.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports